import React, { useEffect, useState } from 'react';
import { AlertCircle } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import apiRequest from '@/services/requests';
import Button from '@/components/ui/Button';

const SystemAnnouncementBar = () => {
const navigate = useNavigate();
const [status, setStatus] = useState(null);

useEffect(() => {
loadStatus();
}, []);

const loadStatus = async () => {
try {
const res = await apiRequest.getSystemStatus();
if (res.success && res.data.status !== 'operational') {
setStatus(res.data);
}
} catch (err) {
console.error('Failed to load system status');
}
};

if (!status || status.status === 'operational') return null;


return (
<div
className="fixed bottom-0 left-0 right-0 z-[9999] bg-red-500 text-white px-3 sm:px-4 py-2"
>
<div className="max-w-[1400px] mx-auto flex flex-col sm:flex-row items-center justify-center gap-2 sm:gap-6 text-center sm:text-left">

<div className="flex items-center justify-center sm:justify-start gap-2 text-xs sm:text-sm">
<AlertCircle size={16} />
<span className="leading-tight">
{status.headline || 'System upgrade in progress. Some features may be affected.'}
</span>
</div>

<button
onClick={() => navigate('/system-status')}
className="font-semibold underline hover:text-yellow-200 text-xs sm:text-sm whitespace-nowrap"
>
Check System Status
</button>

</div>
</div>
);

};

export default SystemAnnouncementBar;
